/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/SlideOutMenu',['pixi', 'absolute', 'lodash', 'MenuUI/MsftSlideOutIconButton', 'MenuUI/RadioGroup', 'MenuUI/MsftToggleButton',
	'util/SettingsManager', 'MenuUI/InputButton', 'version', 'MenuUI/ControlFocusManager', 'MenuUI/MsftButton',
	'MenuUI/MsftIconButton', 'MenuUI/SideBar', 'util/eventhandler', 'Managers/ScaleManager', 'Managers/ScrollManager'],

	function (PIXI, Absolute, _, IconButton, RadioGroup, MsftToggleButton, SettingsManager, InputButton, Version,
		ControlFocusManager, MsftButton, MsftIconButton, SideBar, EventHandler, ScaleManager, ScrollManager) {

		var SlideOutMenu = function (config) {

			var defaultConfig = {
				backgroundColor: 0x000001,
				defaultWidth: 360,
				width: 360,
				height: 658,
				breakPointWidth: 262.2,
				verticalBreakPoint: 640,
				verticalThreshold: 500,
				buttonHandler: '',
				contentLayout: '',
				isMainMenu: false,
				'position': {
					'x': 0,
					'y': 66
				}
			};
			this.initSlideOutMenu(_.extend(defaultConfig, config));
		};
		SlideOutMenu.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		SlideOutMenu.prototype.initSlideOutMenu = function (config) {

			PIXI.DisplayObjectContainer.call(this);

			if (_.isArray(config.contentLayout)) {
				_.each(config.contentLayout, function (configKey) {
					var config = Absolute.UIBuilder.getConfigData(configKey);
					//this.layoutConfig = _.extend(this.layoutConfig || {}, config);
					this.layoutConfig = _.merge(this.layoutConfig || {}, config, function (a, b) {
						if (_.isArray(a)) {
							return a.concat(b);
						}
					});
				}, this);
			} else {
				this.layoutConfig = Absolute.UIBuilder.getConfigData(config.contentLayout);
			}


			this.config = _.extend(config, this.layoutConfig);
			this.settingsManager = SettingsManager;
			this.buttons = [];
			this.currentButtonIndex = -1;

			this.isOpen = false;
			this.slideOutStart = 0;
			this.slideOutEnd = Absolute.Coords.x(1920) / ScaleManager.width;
			this.scale.set(1, 1);
			this.x = Absolute.Coords.x(this.config.position.x);
			this.y = Absolute.Coords.y(this.config.position.y);
			this.initBackground();
			this.initLayoutMask();
			this.initTouchContainer();
			this.controlFocusManager = new ControlFocusManager();

			this.buildLayout();
			this.initSideBar();
			this.isSubMenuOpen = false;
			this.onSubMenuToggle = new EventHandler();
			ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
			this.config.width = this.width;
			this.config.height = this.height;
			this.visible = false;
			this.scale.set(0, 0);
			this.isUnopened = true;
		};


		SlideOutMenu.prototype.initSideBar = function () {
			this.sideBar = new SideBar({ availableHeight: 100, partialHeight: 20 });
			this.sideBar.setListenersForHandleInteraction(
				function () {
					this.enableButtons(false);
				}.bind(this),
				function () {
					this.enableButtons(true);
				}.bind(this)
			);
			this.sideBar.position.set(Absolute.Coords.x(340), 0);
			this.updateSideBar();
			this.addChild(this.sideBar);
		};

		SlideOutMenu.prototype.updateSideBar = function () {
			if(Absolute.Platform.isMobile() && this.parent){
				// Not sure why this sclaing only work for mobile. On desktop while in a game, this scale is off.
				const screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
				this.y = this.parent.game.menuBar.menuBarHeight / screenScaleY * 0.7;
			}
			this.layoutGroup.updateTransform();
			var res = Absolute.ScreenMetrics.getResScale();
			var verticalThreshold = Absolute.Coords.y(this.config.verticalThreshold);
			var layoutHeight = this.layoutGroup.height + Absolute.Coords.y(40),
				screenHeight = ((ScaleManager.height < verticalThreshold) ? verticalThreshold : ScaleManager.height);
			if ((ScaleManager.width < this.config.verticalBreakPoint)) {
				screenHeight *= (this.config.defaultWidth / this.config.breakPointWidth) * res;
			}
			screenHeight -= (this.y / this.scale.y);
			this.layoutHeight = layoutHeight;
			this.screenHeight = screenHeight;
			if (screenHeight < layoutHeight) {
				if (this.layoutGroup.y < 0) {
					if ((screenHeight + Math.abs(this.layoutGroup.y)) > layoutHeight) {
						this.layoutGroup.y = (screenHeight - layoutHeight);
					}
				}
				this.sideBar.visible = true;
				this.sideBar.resetDimensions(layoutHeight, screenHeight, function (p) {
					var y = -(Math.abs(layoutHeight - screenHeight)) * p / 100;
					this.layoutGroup.y = y;
				}.bind(this), screenHeight);
				if (this.sideBar) this.sideBar.updateHandleByPercent(100 * Math.abs(this.layoutGroup.y) / Math.abs(screenHeight - layoutHeight));
			} else {
				this.layoutGroup.y = 0;
				this.sideBar.visible = false;
			}
		};

		SlideOutMenu.prototype.initLayoutMask = function () {
			this.layoutMask = new PIXI.Graphics();
			this.layoutMask.beginFill(0xffff33, 0.4);
			this.layoutMask.drawRect(0, 0, Absolute.Coords.x(this.config.width), 40000);
			this.layoutMask.endFill();
			if (this.layoutGroup) this.layoutGroup.mask = this.layoutMask;
			this.addChild(this.layoutMask);
		};

		SlideOutMenu.prototype.initBackground = function () {
			this.background = new PIXI.Graphics();
			this.background.beginFill(this.config.backgroundColor, 1);
			this.background.drawRect(0, 0, Absolute.Coords.x(this.config.width), 40000);
			this.background.endFill();
			this.background.interactive = true;
			this.background.hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(this.config.width), 40000);
			this.bindInteraction(this.background, function () {
				//console.log('catch click otherwise options close on mis-click');
			});
			this.addChild(this.background);
		};

		SlideOutMenu.prototype.initTouchContainer = function () {
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(this.config.width), 40000);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend =
				this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);
		};

		SlideOutMenu.prototype.bindInteraction = function (sprite, handler) {

			sprite.interactive = true;
			sprite.buttonMode = true;

			if (Absolute.Platform.supportsTouch()) {
				sprite.touchstart = handler.bind(this);
				if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
					sprite.mousedown = handler.bind(this);
					sprite.mouseup = function () {
					};
				}
			} else {
				sprite.mousedown = handler.bind(this);
				sprite.mouseup = function () {
				};
			}

		};

		SlideOutMenu.prototype.buildLayout = function () {
			this.layoutGroup = new PIXI.DisplayObjectContainer();
			var padding = Absolute.Coords.y(15),
				totalSections = this.layoutConfig.buttonSections ? this.layoutConfig.buttonSections.length : 0,
				sectionCount = 0,
				previousItemY = padding;

			if (this.config.isSubMenu) {
				this.backCircleButton = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
				this.backCircleButton.interactive = true;
				var upContainer = new PIXI.DisplayObjectContainer(), downContainer = new PIXI.DisplayObjectContainer();
				upContainer.addChild(PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png"));
				downContainer.addChild(PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Down.png"));
				this.backCircleButton.downTexture = downContainer.generateTexture();
				this.backCircleButton.upTexture = upContainer.generateTexture();
				this.backCircleButton.handleAction = function () {
					if (this.parent && this.parent.handleCommand) {
						this.parent.handleCommand('Back');
					}
				}.bind(this);
				this._modifyButtonInput(this.backCircleButton);
				this.backCircleButton.x = Absolute.Coords.x(25);
				this.backCircleButton.y = Absolute.Coords.y(40);
				this.layoutGroup.addChild(this.backCircleButton);
			}

			_.each(this.layoutConfig.buttonSections, function (sectionData) {

				sectionCount++;
				if (sectionData.hideOnMainMenu && this.config.isMainMenu) {
					return;
				}

				// build title if its there
				var buttonCount = 0,
					title,
					titleLetterStyle = {
						font: Absolute.ScreenMetrics.getResScale() * 28 + "px Arial",
						fontFamily: 'segoe',
						fill: '#ffffff',
						align: 'left'
					},
					description,
					descriptionLetterStyle = {
						font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
						fontFamily: 'segoe',
						fill: '#bcc4c6',
						align: 'left'
					},
					hr;

				if (sectionData.title !== '') {
					title = new PIXI.Text(Absolute.StringManager(sectionData.title), titleLetterStyle);
					title.x = Absolute.Coords.x(40);
					title.y = previousItemY + padding;
					previousItemY = title.y + title.height + (sectionData.titlePadding ? Absolute.Coords.y(sectionData.titlePadding) : Absolute.Coords.y(-8));
					if (this.config.isSubMenu) {
						title.x += Absolute.Coords.x(40);
						title.y += Absolute.Coords.y(20);
						previousItemY += Absolute.Coords.y(40);
					}
					this.layoutGroup.addChild(title);
					buttonCount++;
				}

				if (typeof sectionData.description !== 'undefined' && sectionData.description !== '') {
					description = new PIXI.Text(Absolute.StringManager(sectionData.description, [Version.shortVersion()]), descriptionLetterStyle);
					description.x = Absolute.Coords.x(50);
					description.y = previousItemY + padding;
					previousItemY = description.y + description.height + (sectionData.titlePadding ? Absolute.Coords.y(sectionData.titlePadding) : padding * 1.5);
					this.layoutGroup.addChild(description);
					buttonCount++;
				}

				_.each(sectionData.buttons, function (buttonData) {

					if (buttonData.hideOnMainMenu && this.config.isMainMenu) {
						return;
					}

					if (typeof buttonData.action !== 'function' && buttonData.id && buttonData.id.toLowerCase().indexOf('fullscreen') > -1) {
						// check for fullscreen support before displaying the button
						if (!this.config.fullScreenEnabled) return;
						if (!Absolute.Platform.supportsFullscreenApi() && Absolute.Platform._isIE()) {
							buttonData.text = "buttons.toggleFullScreen";
						} else if (!Absolute.Platform.supportsFullscreenApi()) {
							return;
						}
					}

					if (this.config.isSubMenu) {
						buttonData.hoverColor = 0x56739b;
					} else {
						buttonData.hoverColor = 0x00275e;
					}

					// make sure this data has not been processed already
					if (typeof buttonData.action !== 'function') {
						buttonData.text = Absolute.StringManager(buttonData.text);
						buttonData.action = this.config.buttonHandler[buttonData.action];
					}

					var buttonType = buttonData.type || 'iconButton',
						buttonHeight = Absolute.Coords.x(53),
						button,
						setting = buttonData.settingsKey && sectionData.settingsPrefix ? this.settingsManager.getSetting(sectionData.settingsPrefix, buttonData.settingsKey) : null;

					switch (buttonType) {
						case 'button':
							_.extend(buttonData, {
								'threeSlice': {
									multistate: true,
									images: {
										'left': Absolute.AssetMap('buttonThreeSliceGrey.left'),
										'center': Absolute.AssetMap('buttonThreeSliceGrey.center'),
										'right': Absolute.AssetMap('buttonThreeSliceGrey.right')
									}
								},
								'width': Absolute.Coords.x(255), 'height': Absolute.Coords.y(36),
								'letterStyle': {
									font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
									fontFamily: 'segoe',
									fill: '#000001',
									align: 'left'
								}
							});
							button = new MsftButton(buttonData);
							button.updateState = this.config.buttonHandler[buttonData.updateState];
							button.x = Absolute.Coords.x(55);
							previousItemY -= 2 / Absolute.ScreenMetrics.getResScale();
							break;
						case 'iconButton':
							button = new IconButton(buttonData);
							break;
						case 'radio':
							button = new RadioGroup(_.extend(buttonData, {
								'radioButtons': buttonData.options,
								'title': buttonData.text,
								'action': buttonData.action,
								'settingPrefix': sectionData.settingsPrefix,
								'setting': setting
							}));
							buttonHeight = button._height;
							if (buttonData.settingsKey === 'scoringType') {
								buttonHeight -= Absolute.Coords.y(50);
							}
							button.x = Absolute.Coords.x(40);
							break;
						case 'toggle':
							button = new MsftToggleButton(_.extend(buttonData, {
								'settingPrefix': sectionData.settingsPrefix,
								'setting': setting
							}));
							buttonHeight = button._height;
							button.x = Absolute.Coords.x(40);
							break;
						case 'input':
							button = new InputButton(_.extend(buttonData, {
								'settingPrefix': sectionData.settingsPrefix,
								'setting': setting,
								'validate': function (value) {
									return true;
								}
							}));
							buttonHeight = button._height + Absolute.Coords.y(20);
							button.x = Absolute.Coords.x(40);
							break;
						default:
					}
					if (buttonType === 'radio') {
						_.each(button.buttons, function (radioBtn) {
							this._modifyButtonInput(radioBtn);
						}.bind(this));
					} else {
						this._modifyButtonInput(button);
					}

					button.y = previousItemY;
					buttonCount++;
					this.layoutGroup.addChild(button);

					if (!buttonData.hide) {
						previousItemY = button.y + buttonHeight;
					} else {
						button.visible = false;
					}

					if (button instanceof RadioGroup) {
						for (var b = 0; b < button.controlGroup.length; b++) {
							this.controlFocusManager.addControl(button.controlGroup[b], button.controlGroup[b].visible);
						}
					} else {
						this.controlFocusManager.addControl(button, button.visible);
					}
					this.buttons.push(button);


				}, this);


				if (sectionCount == totalSections) {
					// if this is the last section skip the horizontal rule
				} else if (!sectionData.hideHorizontalRule) {
					hr = new PIXI.Graphics();
					hr.moveTo(0, 0);
					hr.lineStyle(Absolute.Coords.x(2), 0xffffff, 1);
					hr.lineTo(Absolute.Coords.x(273), 0);
					hr.x = Absolute.Coords.x(40);
					hr.y = previousItemY + padding;
					previousItemY = hr.y + hr.height;
					this.layoutGroup.addChild(hr);
				}

			}, this);
			if (this.layoutGroup) this.layoutGroup.mask = this.layoutMask;
			this.touchContainer.addChild(this.layoutGroup);
		};

		SlideOutMenu.prototype.toggle = function (completeCallback) {
			if (this.isUnopened) {
				this.isUnopened = false;
				this.scale.set(1, 1);
			}
			var self = this, sourcePos, startPos, endPos;
			if (!this.isOpen) {
				this.isOpen = true;
				ScrollManager.add(this, this.doScroll, this);
				this.visible = true;
			} else {
				this.isOpen = false;
				ScrollManager.remove(this);
				this.controlFocusManager.unfocusCurrentControl();
			}
			sourcePos = 0;
			this.handleResize();
			if (this.isOpen) {
				startPos = sourcePos - this.width;
				endPos = sourcePos;
			} else {
				startPos = sourcePos;
				endPos = sourcePos - this.width;
			}
			this.handleResize();
			if (this.config.isSubMenu) {
				this.isSubMenuOpen = !this.isSubMenuOpen;
				this.onSubMenuToggle.handleEvent(this, this.isSubMenuOpen);
				if (self.isOpen) self.alpha = 1;
				this.menuTween = new TWEEN.Tween({ x: startPos })
					.to({ x: endPos }, 300)
					.easing(TWEEN.Easing.Quadratic.In)
					.onStart(function () {
						self.toggleButtons();
					})
					.onUpdate(function () {
						self.x = this.x;
					})
					.onComplete(function () {
						if (!self.isOpen) {
							self.layoutGroup.y = 0;
							self.visible = false;
							self.alpha = 0;
						}
						if (typeof completeCallback === 'function') {
							completeCallback();
						}
					})
					.start();
			} else {
				if (self.isOpen) self.alpha = 1;
				this.menuTween = new TWEEN.Tween({ x: startPos })
					.to({ x: endPos }, 300)
					.easing(TWEEN.Easing.Quadratic.In)
					.onUpdate(function () {
						self.x = this.x;
					})
					.onComplete(function () {
						if (!self.isOpen) {
							self.layoutGroup.y = 0;
							self.visible = false;
							self.alpha = 0;
						}
						self.toggleButtons();
						// fixes issue with IE where menu stays in the buffer after switching screens
						window.setTimeout(function () {
							if (typeof completeCallback === 'function') {
								completeCallback();
							}
						}, 100)

					})
					.start();
			}

		};

		SlideOutMenu.prototype.handleResize = function () {
			if (!this.isOpen) return;
			this.moveWithHeader();
			var prevY = this.layoutGroup.y;
			this.layoutGroup.y = 0;
			this.sideBar.updateHandleByPercent(0);
			var widthToScale = ScaleManager.width < this.config.verticalBreakPoint
				? this.config.breakPointWidth : this.config.width,
				heightToScale = this.config.height * widthToScale / this.config.width;
			this.width = widthToScale * (Absolute.Coords.x(1920) / ScaleManager.width);
			this.height = heightToScale * (Absolute.Coords.y(1080) / ScaleManager.height);
			var verticalThreshold = Absolute.Coords.y(this.config.verticalThreshold);
			if (ScaleManager.height < verticalThreshold) {
				this.width *= (ScaleManager.height / verticalThreshold);
				this.height *= (ScaleManager.height / verticalThreshold);
			}
			this.layoutGroup.y = prevY;
			this.updateSideBar();
		};

		SlideOutMenu.prototype.toggleButtons = function () {

			_.each(this.buttons, function (button) {
				if (typeof button.onMenuToggle === 'function') {
					button.onMenuToggle(this.isOpen);
				}
			}, this);

		};

		SlideOutMenu.prototype.onShow = function (isMainMenu, gameName) {
			_.each(this.buttons, function (button) {
				if (typeof button.options.setting !== 'undefined') {
					button.updateState(this.settingsManager.getSetting(button.options.settingPrefix, button.options.settingsKey));
					this.checkAndFadeOutSingleTap(button, gameName);
				} else if (button.options.type == 'button') {
					button.updateState();
				}
				this.controlFocusManager.setControlActive(button, button.visible);
			}, this);
		};

		SlideOutMenu.prototype.getButton = function (idSearch) {

			return _.find(this.buttons, function (button) {
				return button.options.id === idSearch;
			});

		};

		SlideOutMenu.prototype.handleCommand = function (command) {
			switch (command) {
				case 'Tab':
				case 'Down':
					this.controlFocusManager.focusNextControl(1);
					break;
				case 'Up':
					this.controlFocusManager.focusNextControl(-1);
					break;
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
			}
		};

		SlideOutMenu.prototype.checkAndFadeOutSingleTap = function (button, gameName) {
			if (button.options.settingsKey !== "singleTapToMove") return;
			if ((gameName) && (gameName === "Pyramid" || gameName === "TriPeaks")) {
				button.alpha = 0.2;
				button.interactive = false;
			} else {
				button.alpha = 1;
				button.interactive = true;
			}
		};

		SlideOutMenu.prototype.handleDragStart = function (data) {
			this.isDragging = true;
			this.dragLastDeltaY = 0;
			this.dragStartY = data.getLocalPosition(this.parent).y;
		};

		SlideOutMenu.prototype.handleDrag = function (data) {
			if (!this.isOpen) return;
			if (!this.isDragging) return;
			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.dragStartY;
			delta /= this.scale.y;
			if (delta === this.dragLastDeltaY) return;
			this.scrollTo(this.layoutGroup.y + (delta - this.dragLastDeltaY));
			this.dragLastDeltaY = delta;
		};

		SlideOutMenu.prototype.handleDragEnd = function (data) {
			if (!this.isDragging) return;
			this.isDragging = false;
		};

		SlideOutMenu.prototype.doScroll = function (e) {
			if (!this.layoutGroup || !this.isOpen) return;
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 35;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			deltaY /= 5;
			this.scrollTo(this.layoutGroup.y + (deltaY * 100));
		};

		SlideOutMenu.prototype.scrollTo = function (y) {
			if (!this.sideBar.visible) return;
			this.layoutGroup.y = y;
			if (this.layoutGroup.y > 0) this.layoutGroup.y = 0;
			var posY = this.screenHeight - this.layoutHeight;
			if (this.layoutGroup.y < posY) {
				this.layoutGroup.y = posY;
			}
			if (this.sideBar) this.sideBar.updateHandleByPercent(100 * Math.abs(this.layoutGroup.y / posY));
		};

		SlideOutMenu.prototype.enableButtons = function (enabled) {
			var i, l;
			for (i = 0, l = this.layoutGroup.children.length; i < l; i++) {
				this.layoutGroup.children[i].interactive = enabled;
			}
		};

		SlideOutMenu.prototype._modifyButtonInput = function (button) {
			if (Absolute.Platform.supportsTouch()) {
				this._bindButtonTouchInput(button);
				if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
					this._bindButtonMouseInput(button);
				}
			} else {
				this._bindButtonMouseInput(button);
			}
		};

		SlideOutMenu.prototype._bindButtonMouseInput = function (button) {
			var changeState = function (button, texture, hasBeenDown) {
				if (texture) button.setTexture(texture);
				button.hasBeenDown = hasBeenDown;
			};
			button.mousedown = function (evt) {
				changeState(button, button.downTexture, true);
			}.bind(button);
			button.mouseover = function (evt) {
				changeState(button, button.overTexture, true);
			}.bind(button);
			button.mouseout = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, true);
			}.bind(button);
			button.mouseupoutside = function () {
				changeState(button, button.upTexture, false);
			}.bind(button);
			button.mouseup = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, false);
				if (typeof button.handleAction === "function") button.handleAction();
			}.bind(button);
		};

		SlideOutMenu.prototype._bindButtonTouchInput = function (button) {
			var changeState = function (button, texture, hasBeenDown) {
				if (texture) button.setTexture(texture);
				button.hasBeenDown = hasBeenDown;
			};
			button.touchstart = function (evt) {
				changeState(button, button.downTexture, true);
			}.bind(button);
			button.touchend = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, false);
				if (typeof button.handleAction === "function") button.handleAction();
			}.bind(button);
			button.touchendoutside = function (evt) {
				changeState(button, button.upTexture, false);
			}.bind(button);
			button.touchmove = function (evt) {
				if (button.getBounds().contains(evt.global.x, evt.global.y)) return;
				changeState(button, button.upTexture, false);
			}.bind(button);
		};

		SlideOutMenu.prototype.destroy = function () {
			ScrollManager.remove(this);
			PIXI.DisplayObjectContainer.prototype.call(this);
		};

		SlideOutMenu.prototype.moveWithHeader = function () {
			var game = this.parent.game;
			if (!game) return;
			var isGame = !!game.solitaire && !!game.solitaire.Authority,
				yScale = Math.max(Math.min((ScaleManager.height / 1080) + 0.3, 1), 0.7),
				xScale = Math.max(Math.min((ScaleManager.width / 1920) + 0.3, 1), 0.7),
				resizeScale = Math.min(yScale, xScale), height = game.menuBar.menuBarHeight,
				headerHeight = !isGame ? (height / (ScaleManager.scaleFactorY)) :
					(resizeScale * (height / ScaleManager.scaleFactorY));
			this.y = headerHeight;
		};

		return SlideOutMenu;

	});

